import React, { Component } from "react"
import Svg from "../../../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../../../helpers/SelectionFactoryHelper"
import Slider from "react-slick"
import { isMobile } from "react-device-detect"

export default class MerchantCarousel extends Component {
  render() {
    var settings = {
      dots: true,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      variableWidth: true,
    }

    return (
      <div className="merchant-carousel">
        <Slider {...settings}>
          {this.props.carouselItems &&
            this.props.carouselItems.map((item, index) => {
              return <CarouselItem key={index} {...item} cssClass={this.props.carouselItems.length > 1 ? "more-margin" : ""} />
            })}
        </Slider>
      </div>
    )
  }
}

class CarouselItem extends Component {
  render() {
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.buttonColor)
    const blockColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.blockColor)
    const imageAlignment = SelectionFactoryHelper.getFromSelectionFactory(this.props.imageAlignment)
    const buttonStyle = this.props.buttonTextColor ? { color: this.props.buttonTextColor } : undefined

    const leftSide = (
      <div className="left-side">
        <img src={this.props.image} data-epi-edit="Image" />
      </div>
    )

    const leftSideTwo = (
      <div className="left-side">
        <img src={this.props.secondImage} data-epi-edit="SecondImage" />
      </div>
    )

    const rightSide = (
      <div className="right-side">
        <div className="category" data-epi-edit="CategoryText">
          {this.props.categoryText}
        </div>
        <h2 data-epi-edit="Heading">{this.props.heading}</h2>
        <div className="maintext" data-epi-edit="Text">
          {this.props.text}
        </div>
        <ul>
          {this.props.uspItems &&
            this.props.uspItems.map((usp, index) => {
              const uspIcon = SelectionFactoryHelper.getFromSelectionFactory(usp.uspIcon)
              return (
                <a href={usp.uspLink ?? undefined} key={`usp${index}`}>
                  <li data-epi-edit="UspText">
                    <Svg iconName={uspIcon} fillColor={"#071143"} />
                    {usp.uspText}
                  </li>
                </a>
              )
            })}
        </ul>
        <a href={this.props.buttonLink}>
          <div className={`button button--small no-shadow ${buttonColor && buttonColor}`} style={buttonStyle}>
            <span className="text" data-epi-edit="ButtonText">
              {this.props.buttonText}
            </span>
          </div>
        </a>
      </div>
    )

    if (this.props.secondImage) {
      return (
        <div className={`slide-inner ${blockColor && blockColor} ${this.props.cssClass}`}>
          <div className="two-img-slide">
            {leftSide}
            {rightSide}
            {leftSideTwo}
          </div>
        </div>
      )
    }

    if (isMobile) {
      return (
        <div className={`slide-inner ${blockColor && blockColor} ${this.props.cssClass}`}>
          {leftSide}
          {rightSide}
        </div>
      )
    }

    return imageAlignment === "left" ? (
      <div className={`slide-inner ${blockColor && blockColor} ${this.props.cssClass}`}>
        {leftSide}
        {rightSide}
      </div>
    ) : (
      <div className={`slide-inner ${blockColor && blockColor} ${this.props.cssClass}`}>
        {rightSide}
        {leftSide}
      </div>
    )
  }
}
